/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/prefer-default-export */
import BigNumber from 'bignumber.js';
import { exchange } from './constants';

// Configure BigNumber
BigNumber.set({
  DECIMAL_PLACES: exchange.MAX_PRECISION,
  ROUNDING_MODE: BigNumber.ROUND_FLOOR,
  EXPONENTIAL_AT: 1e9,
});
BigNumber.config({
  FORMAT: {
    // string to prepend
    prefix: '',
    // decimal separator
    decimalSeparator: '.',
    // grouping separator of the integer part
    groupSeparator: '',
    // primary grouping size of the integer part
    groupSize: 3,
    // secondary grouping size of the integer part
    secondaryGroupSize: 0,
    // grouping separator of the fraction part
    fractionGroupSeparator: ' ',
    // grouping size of the fraction part
    fractionGroupSize: 0,
    // string to append
    suffix: '',
  },
});

/**
 * Used to format num into a predefined precision with additional checks on the passed num
 * @param {number} num
 * @param {Number} p
 * @param withZeros
 * @returns String
 */
export const formatNumber = (num, p = exchange.MAX_PRECISION, withTrailingZeros = true) => {
  if (Number.isNaN(parseFloat(num))) {
    return '0.00';
  }

  // BigNumber can be instansiated from Number, String, or BigNumber
  // https://github.com/MikeMcl/bignumber.js#use
  const bigNum = new BigNumber(num);

  return withTrailingZeros ? bigNum.toFormat(p) : bigNum.decimalPlaces(p).toString();
};

export const formatNumberWithRounding = (num, p = exchange.MAX_PRECISION) => {
  const integerPart = Math.floor(num);
  const decimalPart = num - integerPart;

  const shiftingAmount = 10 ** p;
  const roundedDecimalPart = Math.ceil(decimalPart * shiftingAmount) / shiftingAmount;

  return integerPart + roundedDecimalPart;
};

export const formatNumberWithComma = (num) => {
  if (Number.isNaN(parseFloat(num))) {
    return '-';
  }

  const str = num.toString().split('.');
  let beforeComma = str[0];
  const afterComma = str.length > 1 ? `${str[1]}` : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(beforeComma)) {
    beforeComma = beforeComma.replace(rgx, `$1,$2`);
  }
  if (afterComma === '') {
    return beforeComma;
  }
  return `${beforeComma}.${afterComma}`;
};

export const formatDecimalNumber = (amount, min = 0) => {
  let decimalAmount = amount.trim();
  if (decimalAmount[decimalAmount.length - 1] === ',') {
    decimalAmount = `${decimalAmount.substring(0, decimalAmount.length - 1)}.`;
  }
  decimalAmount = decimalAmount.replace(/,/g, '');
  let formattedAmount = decimalAmount;
  formattedAmount = formattedAmount === '.' || formattedAmount === ',' ? '0.' : formattedAmount;

  if (isNaN(formattedAmount)) return { decimalAmount: null, formattedAmount: null };
  if (parseFloat(formattedAmount) < parseFloat(min) && formattedAmount !== '')
    return { decimalAmount: null, formattedAmount: null };
  formattedAmount =
    formattedAmount.indexOf('.') !== -1 && isNaN(formattedAmount)
      ? formattedAmount.replace('.', ',')
      : formattedAmount;

  if (formattedAmount.indexOf('.') === -1) {
    formattedAmount = formattedAmount.replace(/^0+/, '');
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(formattedAmount)) {
      formattedAmount = formattedAmount.replace(rgx, `$1,$2`);
    }
    formattedAmount = formattedAmount === '' && amount.trim() !== '' ? '0' : formattedAmount;
  } else {
    const splittedDecimal = formattedAmount.split('.');
    let intAmount = splittedDecimal[0].replace(/^0+/, '');
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(intAmount)) {
      intAmount = intAmount.replace(rgx, `$1,$2`);
    }
    formattedAmount = `${splittedDecimal[0] === '0' ? '0' : intAmount}.${splittedDecimal[1]}`;
  }

  return {
    decimalAmount: decimalAmount || 0,
    formattedAmount: formattedAmount || '0',
  };
};

export const calculateMonthlyInterest = (interestApr, principle) => {
  const interestAprSafe = new BigNumber(interestApr);
  const monthlyInterest = interestAprSafe
    .dividedBy(100)
    .dividedBy(12)
    .multipliedBy(principle)
    .toFixed(exchange.FIAT_VALUE, BigNumber.ROUND_UP);
  return monthlyInterest;
};

export const addDecimalToNumber = (amount) => {
  const valueDecimal = amount.indexOf('.') !== -1 ? amount.split('.') : `${amount}.`.split('.');
  if (valueDecimal.length > 0 && valueDecimal[1].length <= 7) {
    let decimalString = '';
    for (let i = 0; i < 8 - valueDecimal[1].length; i++) {
      decimalString += '0';
    }
    const valueWithDecimal = `${valueDecimal[0]}.${valueDecimal[1]}${decimalString}`;
    const charactersLength = valueWithDecimal.length > 1 ? valueWithDecimal.length : 1;
    return { valueWithDecimal, charactersLength };
  }
  return false;
};

export const formatCryptoAmountOnBlur = (amount) => {
  const trimmedAmount = (amount || '').trim();
  if (!trimmedAmount || parseFloat(trimmedAmount.replace(/,/g, '')) === 0) {
    return { valueWithDecimal: '0', charactersLength: 1 };
  }
  return addDecimalToNumber(trimmedAmount);
};

export const formatWithDecimal = (number, fixedDecimal = 2) =>
  parseInt(number, 10) === number ? number : number.toFixed(fixedDecimal);
